import React, { ChangeEvent } from 'react';
import Slider from '@material-ui/core/Slider';
import { container } from 'tsyringe';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { ConnectionType } from '@base/features/game/model/interfaces';
import styles from '../styles/createTableEntryFee.module.scss';
import { t } from '@base/utils/helpers';

export const CreateTableEntryFee = (props: {
  cost: number;
  handlerEntryFee: (value: number) => void;
  typeGame: string;
}) => {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const { typeGame, cost, handlerEntryFee } = props;

  function renderTicketOptions() {
    const limitTickets = getMoneyLimit();
    const priceOptions = [];
    let i;
    if (typeGame === ConnectionType.CONNECT_TOURNEY_ROOM) {
      priceOptions.push({ value: 0, label: '0' });
    }
    priceOptions.push({ value: 1, label: '1/2 ' });
    priceOptions.push({ value: 2, label: '1' });
    priceOptions.push({ value: 4, label: '2' });
    priceOptions.push({ value: 6, label: '3' });
    for (i = 5; i < 100 && i <= limitTickets; i += 5) {
      priceOptions.push({ value: i * 2, label: i });
    }
    for (i = 100; i < 150 && i <= limitTickets; i += 10) {
      priceOptions.push({ value: i * 2, label: i });
    }
    for (i = 150; i <= 200 && i <= limitTickets; i += 25) {
      priceOptions.push({ value: i * 2, label: i });
    }
    return priceOptions;
  }

  const marks = renderTicketOptions();
  const maxLength = marks[marks.length - 1].value;

  function getLabel() {
    let label = '';
    marks.forEach((elem) => {
      if (elem.value === cost) {
        label = String(elem.label);
      }
    });
    return label;
  }

  function getMoneyLimit() {
    if (playersOnlineRepository.me) {
      return playersOnlineRepository.me.getMoneyLimit();
    }
    return 10;
  }

  const handleSliderChange = (event: ChangeEvent<Record<string, unknown>>, newValue: number | number[]) => {
    if (typeof newValue === 'number') {
      handlerEntryFee(newValue);
    }
  };

  return (
    <section className="slider-wrap">
      <div className={styles.entryTitle}>
        <div>{t('entry_fee')}</div>
        <div>{getLabel()}</div>
      </div>
      <Slider value={cost} onChange={handleSliderChange} step={null} max={maxLength} marks={marks} />
    </section>
  );
};
